import {
  closedOpenExceptionsDatePickerSlice,
  reservationBlockedWeekdaysSlice,
  reservationZoneSlice,
  openTimeSlice,
  createReservationSlice,
  cancelReservationSlice,
  editReservationSlice,
  reservationCustomersMenuSlice,
  reservationActiveSlice,
  reservationLimitPeopleBabySlice,
  reservationPhoneOrEmailConfirmationSlice,
} from "../reducers/reservationReducers";
import { api } from "../App";
import { placeOfTableSlice } from "../reducers/restaurantReducers";
import {
  fetchReservations,
  getReservationSums,
  changeTables,
  fetchAllReservations,
} from "../actions/restaurantActions";

const {
  openClosedExceptionsRequest,
  openClosedExceptionsSucess,
  openClosedExceptionsError,
} = closedOpenExceptionsDatePickerSlice.actions;

export const fetchOpenClosedExceptions = (id) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        nothing: "nothing",
      };
    }

    dispatch(openClosedExceptionsRequest());

    await api
      .get(`/reservations/get/open_closed_exceptions/${id}/`, config)
      .then((response) => dispatch(openClosedExceptionsSucess(response.data)));
  } catch (error) {
    dispatch(
      openClosedExceptionsError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

const {
  reservationBlockedWeekdaysRequest,
  reservationBlockedWeekdaysSucess,
  reservationBlockedWeekdaysError,
  isRestaurantOpenTodayRequest,
  isRestaurantOpenTodaySucess,
  isRestaurantOpenTodayError,
  restaurantTimeZoneRequest,
  restaurantTimeZoneSucess,
  restaurantTimeZoneError,
} = reservationBlockedWeekdaysSlice.actions;

export const fetchReservationBlockedWeekdays =
  (id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(reservationBlockedWeekdaysRequest());

      await api
        .get(`/reservations/get/blockedweekdays/${id}/`, config)
        .then((response) =>
          dispatch(reservationBlockedWeekdaysSucess(response.data)),
        );
    } catch (error) {
      dispatch(
        reservationBlockedWeekdaysError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const checkIfrestaurantIsOpenToday =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
      dispatch(isRestaurantOpenTodayRequest());

      await api
        .get(
          `/reservations/check_restaurant_open_today/${restaurant_id}/`,
          config,
        )
        .then((response) =>
          dispatch(isRestaurantOpenTodaySucess(response.data)),
        );
    } catch (error) {
      dispatch(
        isRestaurantOpenTodayError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const getRestaurantTimeZone =
  (restaurant_id) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(restaurantTimeZoneRequest());

      await api
        .get(`/reservations/getRestaurantTimeZone/${restaurant_id}/`, config)
        .then((response) => dispatch(restaurantTimeZoneSucess(response.data)));
    } catch (error) {
      dispatch(
        restaurantTimeZoneError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const { reservationZoneRequest, reservationZoneSucess, reservationZoneError } =
  reservationZoneSlice.actions;

export const fetchZones = (id) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(reservationZoneRequest());

    await api
      .post(`/reservations/get/zones/`, { id: id }, config)
      .then((response) => dispatch(reservationZoneSucess(response.data)));
  } catch (error) {
    dispatch(
      reservationZoneError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

const { openTimeRequest, openTimeSucess, openTimeError } =
  openTimeSlice.actions;

export const fetchOpenTime =
  (id, date, numberOfPeople, token = false, ignoreLimitations = false) =>
  async (dispatch, getState) => {
    try {
      const config = {
        headers: {
          nothing: "nothing",
        },
      };
      if (date != null) {
        dispatch(openTimeRequest());
        await api
          .post(
            `/reservations/post/getavailabletimes/`,
            {
              id: id,
              date: date,
              numberOfPeople: numberOfPeople,
              token: token,
              ignoreLimitations: ignoreLimitations,
            },
            config,
          )
          .then((response) => dispatch(openTimeSucess(response.data)));
      }
    } catch (error) {
      dispatch(
        openTimeError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  createReservationRequest,
  createReservationSucess,
  createReservationError,
  resetReservationError,
  toastCreateSuccess,
  toastCreateCancel,
  postPhoneConfirmationStart,
  postPhoneConfirmationSucess,
  postPhoneConfirmationError,
  postResendPhoneConfirmationStart,
  postResendPhoneConfirmationSucess,
  postResendPhoneConfirmationError,
  startCreateLoader,
  stopCreateLoader,
  postCheckCancelStart,
  postCheckCancelSucess,
  postCheckCancelError,
  postReconfirmationByClient,
  postReconfirmationByClientSucess,
  postReconfirmationByClientError,
} = createReservationSlice.actions;

export const fetchCreateReservation =
  (
    id,
    date,
    numberOfPeople,
    shift,
    time,
    name,
    email,
    phone_number,
    country_code,
    baby_chair,
    message,
    placeOfTable,
    subscription,
    accessability,
    isItFromRestaurant = false,
    reservation_or_waiting_list,
    autoOrManualTables,
    tables_used_list,
    restaurant_note,
  ) =>
  async (dispatch, getState) => {
    let reservationInfo; // Define it here, outside the try block

    try {
      console.log("placeOfTable: -  -- - -- ", placeOfTable);
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(createReservationRequest());
      // Initialize reservationInfo here so it is in scope for both try and catch blocks
      reservationInfo = {
        id: id,
        date: date,
        numberOfPeople: numberOfPeople,
        shift: shift,
        time: time,
        name: name,
        email: email,
        phone_number: phone_number,
        baby_chair: baby_chair,
        message: message,
        placeOfTables:
          placeOfTable === "Não definir sala" ? null : placeOfTable,
        subscription: subscription,
        accessability: accessability,
        isItFromRestaurant: isItFromRestaurant,
        country_code: country_code,
        reservation_or_waiting_list: reservation_or_waiting_list,
        autoOrManualTables: autoOrManualTables,
        tables_used_list: tables_used_list,
        restaurant_note: restaurant_note,
      };
      const response = await api.post(
        `/reservations/post/createReservation/`,
        reservationInfo,
        config,
      );

      dispatch(createReservationSucess(response.data));
      localStorage.setItem("createReservation", JSON.stringify(response.data));
      dispatch(fetchReservationCustomerMenu(response.data.token, "no", true));

      if (response.data.error) {
        console.error("response.data.error", response.data.error);
      }
    } catch (error) {
      dispatch(
        createReservationError({
          error: error.response ? error.response.data.detail : error.message,
          reservationInfo: reservationInfo, // Now accessible here
        }),
      );
    }
  };

export const postPhoneConfirmation =
  (token, action) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(postPhoneConfirmationStart());
      const response = await api.post(
        `/reservations/phone_confirmation/${token}/${action}/`,
        {},
        config,
      );
      dispatch(postPhoneConfirmationSucess(response.data));
      dispatch(fetchReservationCustomerMenu(token, "no", true));
    } catch (error) {
      dispatch(
        postPhoneConfirmationError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const checkCancelAction = (token) => async (dispatch, getState) => {
  try {
    const {
      userLogin: { userInfo },
    } = getState();
    let config;
    if (userInfo) {
      config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };
    } else {
      config = {
        headers: {
          nothing: "nothing",
        },
      };
    }
    dispatch(postCheckCancelStart());
    const response = await api.post(
      `/reservations/warning_check/${token}/`,
      {},
      config,
    );
    dispatch(postCheckCancelSucess(response.data));
  } catch (error) {
    dispatch(
      postCheckCancelError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

export const postResendPhoneConfirmation =
  (token, country_code, phone_number, email) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(postResendPhoneConfirmationStart());

      const response = await api.post(
        `/reservations/resend_phone_confirmation/${token}/${country_code}/${phone_number}/${email}/`,
        {},
        config,
      );

      dispatch(postResendPhoneConfirmationSucess(response.data));

      dispatch(fetchReservationCustomerMenu(token, "no", true));
    } catch (error) {
      dispatch(
        postResendPhoneConfirmationError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const reconfirmationByClientAction =
  (token) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(postReconfirmationByClient());

      const response = await api.post(
        `/reservations/reconfirmation_confirmed/${token}/`,
        {},
        config,
      );

      dispatch(postReconfirmationByClientSucess(response.data));
    } catch (error) {
      dispatch(
        postReconfirmationByClientError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const fetchResetReservation = () => async (dispatch) => {
  dispatch(resetReservationError());
};
const {
  cancelReservationRequest,
  cancelReservationSucess,
  cancelReservationError,
} = cancelReservationSlice.actions;

export const fetchCancelReservation =
  (id, isCustomer = false, restaurant_id, rejectEdition = false) =>
  async (dispatch, getState) => {
    console.log("inside usereffect: ", id);
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(cancelReservationRequest());
      const data = {
        reservation_id: id,
        isCustomer: isCustomer,
        rejectEdition: rejectEdition ? 1 : 0,
      };
      await api
        .post(`/reservations/cancel_reservation/`, data, config)
        .then((response) => dispatch(cancelReservationSucess(response.data)));
      if (restaurant_id !== false) {
        dispatch(getReservationSums(restaurant_id));
      }
    } catch (error) {
      dispatch(
        cancelReservationError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const { editReservationRequest, editReservationSucess, editReservationError } =
  editReservationSlice.actions;

export const fetchEditReservation =
  (
    token,
    id,
    reservation_id,
    date,
    numberOfPeople,
    shift,
    time,
    name,
    phone_number,
    country_code,
    baby_chair,
    message,
    placeOfTable,
    subscription,
    accessability,
    ignoreLimitations = false,
    from_restaurant,
    isTablesChangedManually,
    tables_used_list,
    restaurant_note,
    accept_and_notify_client = false,
    email,
  ) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      console.log("data payload edit resercation: ", {
        id: id,
        reservation_id: reservation_id,
        date: date,
        numberOfPeople: numberOfPeople,
        time: time,
        name: name,
        phone_number: phone_number,
        message: message,
        placeOfTables: placeOfTable,
        country_code: country_code,
        ignoreLimitations: ignoreLimitations,
        from_restaurant: from_restaurant,
        isTablesChangedManually: isTablesChangedManually,
        tables_used_list: tables_used_list,
        restaurant_note: restaurant_note,
        baby_chair: baby_chair,
        accessability: accessability,
        accept_and_notify_client,
        notify_customer: accept_and_notify_client,
      });
      dispatch(editReservationRequest());
      const response = await api.post(
        `/reservations/edit_reservation/`,
        {
          id: id,
          reservation_id: reservation_id,
          date: date,
          numberOfPeople: numberOfPeople,
          time: time,
          name: name,
          phone_number: phone_number,
          message: message,
          placeOfTables: placeOfTable,
          country_code: country_code,
          ignoreLimitations: ignoreLimitations,
          from_restaurant: from_restaurant,
          isTablesChangedManually: isTablesChangedManually,
          tables_used_list: tables_used_list,
          restaurant_note: restaurant_note,
          baby_chair: baby_chair,
          accessability: accessability,
          accept_and_notify_client,
          notify_customer: accept_and_notify_client,
          email,
        },
        config,
      );
      dispatch(editReservationSucess(response.data));
      dispatch(fetchReservationCustomerMenu(token, "no", true));
    } catch (error) {
      dispatch(
        editReservationError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  getReservationCustomerRequest,
  getReservationCustomerSucess,
  getReservationCustomerError,
  resetReservationCustomerMenu,
  startCustomerMenuLoader,
  stopCustomerMenuLoader,
} = reservationCustomersMenuSlice.actions;

export const fetchReservationCustomerMenu =
  (reservation_id, change_satatus, isLoader = false) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      if (isLoader) {
        dispatch(startCustomerMenuLoader());
      }

      dispatch(getReservationCustomerRequest());

      await api
        .get(
          `/reservations/customersmenu/${reservation_id}/${change_satatus}`,
          config,
        )
        .then((response) => {
          dispatch(getReservationCustomerSucess(response.data));
        });

      if (isLoader) {
        dispatch(stopCustomerMenuLoader());
      }
    } catch (error) {
      dispatch(
        getReservationCustomerError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

export const ResetReservation = () => async (dispatch) => {
  dispatch(resetReservationCustomerMenu());
};

const { getPeopleBabyRequest, getLimitsPeopleBabySucess, getPeopleBabyError } =
  reservationLimitPeopleBabySlice.actions;

export const fetchReservationLimitPeopleBaby =
  (
    reservation_id,
    date,
    time = null,
    number_of_people = null,
    reservation_token,
  ) =>
  async (dispatch, getState) => {
    try {
      /*       const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      } */
      const config = {
        headers: {
          nothing: "nothing",
        },
      };
      dispatch(getPeopleBabyRequest());
      await api
        .get(
          `/reservations/reservation-limits/${reservation_id}/${date}/${time}/${number_of_people}/${
            reservation_token === "no_id" ? "0" : reservation_token
          }/`,
          config,
        )
        .then((response) => dispatch(getLimitsPeopleBabySucess(response.data)));
    } catch (error) {
      dispatch(
        getPeopleBabyError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  getReservationActiveRequest,
  getReservationActiveError,
  getReservationDeactivateRequest,
} = reservationActiveSlice.actions;

export const fetchReservationActive = () => async (dispatch, getState) => {
  try {
    dispatch(getReservationActiveRequest());
  } catch (error) {
    dispatch(
      getReservationActiveError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

export const fetchReservationDeactivate = () => async (dispatch) => {
  try {
    dispatch(getReservationDeactivateRequest());
  } catch (error) {
    dispatch(
      getReservationActiveError(
        error.response && error.response.data.detail
          ? error.response.data.detail
          : error.message,
      ),
    );
  }
};

const {
  reservationUpdateStart,
  reservationUpdateSucess,
  reservationUpdateError,
} = createReservationSlice.actions;

export const updateReservation =
  (reservation_id, params, isLateUpdate = false) =>
  async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();

      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }

      // Add isLateUpdate flag to params
      const updatedParams = { ...params, isLateUpdate };
      dispatch(reservationUpdateStart());
      await api
        .patch(`/reservations/update/${reservation_id}/`, updatedParams, config)
        .then((response) => dispatch(reservationUpdateSucess(response.data)));
    } catch (error) {
      dispatch(
        reservationUpdateError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };

const {
  getPhoneOrEmailConfirmationRequest,
  getPhoneOrEmailConfirmationSucess,
  getPhoneOrEmailConfirmationError,
} = reservationPhoneOrEmailConfirmationSlice.actions;

export const postPhoneOrEmailConfirmation =
  (token, phone_or_email) => async (dispatch, getState) => {
    try {
      const {
        userLogin: { userInfo },
      } = getState();
      let config;
      if (userInfo) {
        config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.token}`,
          },
        };
      } else {
        config = {
          headers: {
            nothing: "nothing",
          },
        };
      }
      dispatch(getPhoneOrEmailConfirmationRequest());
      await api
        .post(
          `/reservations/phone_or_email_confirmation/${token}/${phone_or_email}/`,
          config,
        )
        .then((response) =>
          dispatch(getPhoneOrEmailConfirmationSucess(response.data)),
        );
    } catch (error) {
      dispatch(
        getPhoneOrEmailConfirmationError(
          error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message,
        ),
      );
    }
  };
